import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { ChargingStatistics } from './charging-statistics-model';
import { StatisticsPeriod } from './statistics-period.model';

@JsonObject()
export class StationGroupId {
  @JsonProperty('Value') value: string;
}

@JsonObject()
export class StationGroupChargingStatistics extends ChargingStatistics {
  @JsonProperty('StationGroupId') stationGroupId: StationGroupId;
  @JsonProperty('StationGroupName') stationGroupName: string;
  @JsonProperty('Period') period: StatisticsPeriod;
  @JsonProperty({ name: 'ByDay', type: ChargingStatistics }) byDay: Array<ChargingStatistics>;
}
